export default __webpack_public_path__ + "static/media/Wattson-award.f008f655.jpg";